import {validateEmail} from "../utils/validateEmail";
import {subscriberApi} from "../api/subscriber";
import {
    ERROR_FORM_STATUS_TEXT,
    ERROR_FORM_STATUS_TITLE,
    SUCCESS_SUBSCRIBE_FORM_STATUS_TEXT,
    SUCCESS_SUBSCRIBE_FORM_STATUS_TITLE
} from "../constants";

export default () => ({
    email: '',
    fieldsValidationState: {
        email: false,
    },
    loading: false,
    async onSend() {
        let validationCorrect = true;
        if (this.email.length === 0 || !validateEmail(this.email)) {
            validationCorrect = false;
            this.fieldsValidationState.email = true;
        }
        if (!validationCorrect) {
            return false;
        }
        this.loading = true;
        try {
            await subscriberApi.create({
                email: this.email,
            });
            this.$store.formStatusPopup.open('success', SUCCESS_SUBSCRIBE_FORM_STATUS_TITLE, SUCCESS_SUBSCRIBE_FORM_STATUS_TEXT);
            this.resetForm();
        } catch (error) {
            this.$store.formStatusPopup.open('error', ERROR_FORM_STATUS_TITLE, ERROR_FORM_STATUS_TEXT);
        }
        this.loading = false;
    },
    resetForm() {
        this.email = '';
        this.fieldsValidationState.email = false;
    },
    init() {
        this.$watch('email', () => {
            this.fieldsValidationState.email = false;
        });
    }
});